import {httpsCallable} from 'firebase/functions'
import {projectAuth,functions} from '../firebase/config'
import store from '../store'
import {createUsageTracker} from './accountUsageTrackingCore.mjs'
let stop
export function startAccountUsageTracking(){
 if(stop||typeof window==='undefined')return stop
 const call=httpsCallable(functions,'recordAccountUsageV2',{timeout:10000})
 let warned=false
 const tracker=createUsageTracker({
  send:payload=>call(payload),
  scope:()=>{const auth=projectAuth.currentUser,owner=store.state.accountOwnerId||store.state.currentUser?.uid;return auth&&owner&&store.state.infoLoaded&&store.state.authUser?.uid===auth.uid?`${owner}:${auth.uid}`:''},
  visible:()=>document.visibilityState==='visible',
  onError:()=>{if(!warned){warned=true;console.warn('Account usage tracking is unavailable; normal account actions are unaffected.')}},
 })
 const input=event=>tracker.interact(event),guide=event=>tracker.guide(event.detail)
 const unwatch=store.watch(state=>JSON.stringify([state.infoLoaded,state.authUser?.uid,state.accountOwnerId,state.currentUser?.uid,state.currentDashboardView]),()=>{
  tracker.sync()
  const active=Object.keys(store.state.currentDashboardView||{}).find(key=>store.state.currentDashboardView[key]===true)
  const feature={executive:'reports',accounting:'finance',integrations:'settings'}[active]||active
  if(feature)tracker.feature(feature)
 },{immediate:true})
 window.addEventListener('pointerdown',input,{passive:true});window.addEventListener('keydown',input,{passive:true});window.addEventListener('tintbolt:guide-analytics',guide)
 stop=()=>{unwatch();window.removeEventListener('pointerdown',input);window.removeEventListener('keydown',input);window.removeEventListener('tintbolt:guide-analytics',guide);stop=null}
 return stop
}
